import { Component } from '@angular/core';
import { ATableMenuTab } from './mactable.menu.tab';

@Component({
    selector: 'mactable-expand-menu-tab',
    templateUrl: './expand.menu.tab.html'
})
export class MacTableExpandMenuTab extends ATableMenuTab {
}
